// locals
import FetchFactory from '../factory'

type SignUp = {
  userid: string
  password: string
  email?: string
  accountType: 'GENERAL' | 'TEACHER' | 'STUDENT' | 'NONE'
  yearBirth: number | null
  authTransactionToken?: string
  emailVerificationToken?: string
  terms: { termId: number; isAgree: boolean }[] | undefined // 다른 부분은 term -> terms로 수정했지만, api 통신 부분은 서버 측 변경이 없으므로 AS-IS(term) 유지
}

class SignUpModule extends FetchFactory {
  private SIGNUP = '/signup'
  /**
   * 약관 정보 조회
   * @param type
   * @returns
   */
  getTerms(type: 'NORMAL' | 'UNDER14' | undefined) {
    return this.call<APIResponse<{ terms: TermsContent[] }>>(
      'GET',
      `${this.SIGNUP}/v1/terms`,
      undefined,
      {
        params: { type }
      }
    )
  }
  /**
   * 회원 가입
   * @param data
   * @returns
   */
  async signUp(data: SignUp) {
    // POST 응답 시 data: null(에러) or {}(성공)
    // Record<string, never> = {} 타입 대응
    return this.call<APIResponse<Record<string, never>>>(
      'POST',
      `${this.SIGNUP}/v1`,
      data
    )
  }

  // 회원 탈퇴 시 약관 상세 조회 용도로 사용하였으나, 해외 법률페이지 작업 시 api 엔드포인트 변경됨(미사용)
  getPolices(termId: number) {
    return this.call<APIResponse<TermsContent>>(
      'GET',
      `${this.SIGNUP}/v1/policies/${termId}`
    )
  }
}

export default SignUpModule
